// extracted by css-extract-rspack-plugin
export default {"validationError":"ValidationError__validationError--TRNBH","invalidRangeText":"ValidationError__invalidRangeText--EF71r"};